import {
  ConsentVideoAppAndWebAttributesType,
  ConsentVideoContentModel,
} from '../generated/types/ConsentVideoContentModel';

const defaultConsentVideoContentMock: ConsentVideoContentModel = {
  _content_type_uid: undefined,
  metadata: {},
  app_and_web_attributes: [
    {
      web: {
        audience: ['CRA'],
        date: '2023-09-18T09:00:00.000Z',
      },
    } as unknown as ConsentVideoAppAndWebAttributesType,
  ],
  client_application: {
    client_value: 'hcp-web' as const,
  },
  consent_type: 'VIDEO_TRAINING_UNIFY_STUDY_INTRO_SSTM',
  countries: {
    country: ['GB'],
  },
  header: 'Unify user training',
  title: 'SSTM Web Study Intro - VIDEO_TRAINING_UNIFY_STUDY_INTRO_SSTM v3.0',
  uid: 'blt7ab3c617eaed884e',
  version: '1.0',
  video: {
    video: {
      content_type: 'video/mp4',
      file_size: '18465671',
      filename: 'videoUrl.mp4',
      relative_path: 'assets/blt3378fba2b4b82e9b/1/videoUrl.mp4',
      title: 'Unify Access Training Video_Support_7.0.mp4-en-gb',
      uid: 'blt3378fba2b4b82e9b',
      url: 'https://dev-dmdp-contentstack-unify-sysops02-content-bucket.s3.eu-west-1.amazonaws.com/dev02/generic/hcp-web/10_0/en_gb/assets/blt3378fba2b4b82e9b/1/videoUrl.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA5K3RUCFNF22NZ3OE%2F20240130%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T124140Z&X-Amz-Expires=3540&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEE0aCWV1LXdlc3QtMSJIMEYCIQDKAviL4k7nab6FiWVwHLt4g1X39cvGalMqPENmTzgPKgIhAMDGJAq2ziCXl8n2hffeqbVc6SjQiyBkNpsdEHaHBA9VKq0FCBYQAxoMOTE2Njc2OTQwMTIyIgw8GXieuB4Z0H3BdboqigVEm15exnpNCNRWaUhZZAx9y%2BALUp%2BM26Hz6Xd5T%2BghhIuoGKuUI78JTCJPsP3Usng%2Fnth6jlTeSV962ZRZR9VfYz9K%2BnT%2FVRwus0aZdIYFyCef9r0CwHDKbTVPXK7Q%2FsdIldOtDA1r0mz0Bv%2F1gSQO6ZrwrBaUJ0LtroVLXoG7lGvOCzYgsGFewb8tc%2BynAh8XMT6H58NS0WkuWqhwUgVWYJyYGZABSAdVkw86U5i8xiRhDFl9Yii77qWo%2FmF5FBLXE1rQQVkhi9mkHUBYeEZaK%2FKt%2BmIzCYHdeil2qsjUEHYjj3NGg3kRKUJ16xqP66lXxrBXNXKb02wdxK7ERmKA%2BVxRmyUoOxTJVAvWXkVAhqdEJmdltO7cXXmIFTKx6lebkEOCXK1MJXpa2Ag7SJFFiY%2Blf5bfmczOQBgNiotpbHhpbbWBc27TSTAykbPbamJgOWdAdAMEXAy%2B4jO9%2FIEFdbqLn6rPWNO6O3Rd9naij3PCvKtbZLLL%2FLcjzHwRzrIsk5k%2FRJDiaumxgXkkqBnNyWD4bS0RkWnC0yEX1CNV6i0CL7MQq0aWEAOuBqJ2Lc3RJW9YTrgzr4RfokCRMyiH6g5VdRYyYeZtCiR5PQUBB2vLDj8QdVVrxQgPrrz%2FRoJAnISa7%2BXjV%2FjhaZQgcaxJdHZYUPxCPjx2viOZcUG94n1zsbhJZD%2BIQQPX4KyzSCavGwsmU3ooYiyCgNfiXMU0uh9wqU3tfkXHh4oy%2Fu0GZp8yud10DGA9Fz7qL8rN%2BIlMTMJkLAIi99cu9B5d3Z0eXRKOT2Jo9xC32VqRX%2F3OM6EKL3xwm14ilBNKxodcA15LR%2FX3Qxt%2BNInNw5fWuGhd8mIFF6%2BA%2BuklrzCE3eOtBjqaAcY30OAclEgTvkuGfHzoqI2jQCqIfv7ZnWABU1KT%2F9DCEpcDtRd2nlNzNUo1Eyuiahyn4V5PGWX2%2FSYwiIRZNU0d%2BaumQwGfkVDXrukO5EHGXZlXJQeLF0DvTldT7M8RorvsCoJsBBL2oPdZhaToIwNLsBC1GckFxbtqSJyUIx982oOyFN4dllnKnUcstqI0Bd7GzkNkcchzt6I%3D&X-Amz-Signature=85161f8215e9b788b87cf6f086fb439ff95ef70a029af9eac0dbf3aec691ff11&X-Amz-SignedHeaders=host&x-id=GetObject',
    },
  },
  video_context: 'PORTAL' as const,
};

const create = (partial?: Partial<ConsentVideoContentModel>): ConsentVideoContentModel => ({
  ...defaultConsentVideoContentMock,
  ...partial,
});

export const ConsentVideoContentModelMock = { create };
